module.exports = __webpack_public_path__ + "static/media/fly0141.6b72f5d5.webp";